import { Link } from "react-router-dom";

export default function TornaAlMenu({ to = "/", onClick }) {
  return (
    <div className="mb-3">
      {onClick ? (
        <button type="button" onClick={onClick} className="btn btn-outline-secondary">
          ⬅️ Torna al menu
        </button>
      ) : (
        <Link to={to} className="btn btn-outline-secondary">
          ⬅️ Torna al menu
        </Link>
      )}
    </div>
  );
}
